<template>
    <v-container fluid class="pa-6 attribute-manager-page">
        <page-bar title="Attribute Manager" subtitle="Manage attributes and clean unused values">
            <template v-slot:actions>
                <v-btn
                    v-if="CanUserAccessCleanAttributeValues()"
                    small
                    color="primary"
                    dark
                    @click="$router.push('/cleanattributevalues')"
                >
                    <v-icon left>mdi-broom</v-icon>
                    Clean Values
                </v-btn>
            </template>
        </page-bar>

        <v-row class="mt-4">
            <v-col cols="12">
                <v-card>
                    <v-card class="pa-2 subtitle-1 attribute-toolbar" color="primaryDark" width="100%" dark flat>
                        <v-row justify="start" align="center" no-gutters>
                            <v-col class="pl-4">Attributes</v-col>
                        </v-row>
                    </v-card>

                    <v-card-text class="pt-4">
                        <Loading v-if="loadingManager" :value="'Loading Attribute Manager...'"></Loading>

                        <template v-else>
                            <Attributes :attributes="attributeManager.allAttributes" v-on:AttributeCreated="reloadManager()"/>
                        </template>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import { mapActions } from 'vuex'
import { mapGetters } from 'vuex'

import Attributes from '../views/attributeManagement/Attributes.vue'
import Loading from '../shared/Loading'
import PageBar from '../shared/PageBar'

export default {
    name: "AttributeManagement",
    components: {
        Attributes,
        Loading,
        PageBar
    },
    mounted:  function () {
        this.GetAttributeManagement()
        .then((response) => {
            this.attributeManager = response.data;
            if (this.attributeManager.allAttributes) {
                this.attributeManager.allAttributes.sort((a, b) => (a.order || 0) - (b.order || 0));
            }
            this.loadingManager = false;
        });       
    },
    props: {
    },
    computed:{
    },
    data: () => ({
        loadingManager: true,
        attributeManager: {}
    }),
    methods: {
        ...mapActions("assetxpstate", [
            "GetAttributeManagement"
        ]),
        ...mapGetters("authentication", [
            "CanUserAccessCleanAttributeValues"
        ]),

        reloadManager()
        {
            this.loadingManager = true;

            this.GetAttributeManagement()
            .then((response) => {
                this.attributeManager = response.data;
                if (this.attributeManager.allAttributes) {
                    this.attributeManager.allAttributes.sort((a, b) => (a.order || 0) - (b.order || 0));
                }
                this.loadingManager = false;
            });
        }
    },
    watch: {
    }
}
</script> 

<style scoped>
.attribute-manager-page :deep(.v-data-table) {
    width: 100%;
}

.attribute-manager-page :deep(.v-data-table th) {
    background-color: #cccccc;
    font-size: 12px;
}

.attribute-manager-page :deep(.v-data-table td) {
    font-size: 11px;
}

.attribute-manager-page :deep(.v-data-table__expanded__row) {
    background: #d3dbde;
}

.attribute-manager-page :deep(.v-data-table__expanded__content) {
     box-shadow: inset 0px 12px 12px 12px rgba(176, 190, 197, 0.75), inset 0px -12px -12px -12px rgba(176, 190, 197, 0.75) !important;
}

.attribute-toolbar {
    border-radius: 0;
}
</style>